import PropTypes from 'prop-types';
import { Scrollbars } from 'rc-scrollbars';
import React, { useCallback, useRef, useState } from 'react';
import { createUseStyles } from 'react-jss';

import { useGame } from '../../../../context';
import Region from './region';

const MAX_HEIGHT = 290;

const useStyles = createUseStyles({
  regions: {
    composes: ['pr20'],
    height: MAX_HEIGHT,
  },
});

const RegionsComponent = React.memo(({ lmap }) => {
  const scrollbar = useRef();
  const classes = useStyles();
  const { map: mapConfig, regions } = useGame();

  const [opened, setOpened] = useState(null);

  const regionClickHandler = useCallback(
    (id, latlng) => {
      const iscurrent = id === opened;
      const current = iscurrent ? null : id;
      setOpened(current);
      const zoom = mapConfig.zoom.current;
      const mapBounds = lmap.getBounds();
      const contained = mapBounds.contains(latlng);
      if (!iscurrent && !contained) {
        lmap.flyTo(latlng, zoom);
      }
    },
    [opened, mapConfig, lmap]
  );

  return (
    <Scrollbars ref={scrollbar} style={{ height: MAX_HEIGHT, width: '100%' }}>
      <div className={classes.regions}>
        {regions.map(region => (
          <Region
            key={region.id}
            opened={opened}
            region={region}
            onClick={regionClickHandler}
          />
        ))}
      </div>
    </Scrollbars>
  );
});

RegionsComponent.propTypes = {
  lmap: PropTypes.shape().isRequired,
};

RegionsComponent.displayName = 'RegionsComponent';

export default RegionsComponent;
